import AuthScaffold from '@features/parent-auth/components/AuthScaffold'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

export const parentAuthRoutesParamSchema = z.object({
    email: z.string().optional(),
    returnUrl: z.string().optional(),
})

export const handleAuthRedirect = async ({ search, context }: { search: z.infer<typeof parentAuthRoutesParamSchema>; context: any }): Promise<any> => {
    const { returnUrl } = search
    const safeReturnUrl = returnUrl && returnUrl.startsWith('/') ? returnUrl : '/home'

    if (context.auth.status === 'authed') {
        throw redirect({ to: safeReturnUrl })
    }

    const { status } = await context.auth.ensureAuth()
    if (status === 'authed') {
        throw redirect({ to: safeReturnUrl })
    }

    return null
}

export const Route = createFileRoute('/_nolayout/_auth')({
    component: AuthScaffold,
    validateSearch: zodValidator(parentAuthRoutesParamSchema),
})